import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _createForOfIteratorHelper from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import api from '@/api';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  name: 'LogEdit',
  data: function data() {
    return {
      title: '',
      form: {
        createTime: null,
        method: '',
        name: '',
        operationType: '',
        operatorId: null,
        operatorName: '',
        requestBody: '',
        responseBody: '',
        runTime: null,
        serviceName: '',
        stats: 0,
        url: '',
        logStats: [],
        logStatsTypes: []
      },
      rules: {
        createTime: [{
          required: true,
          message: '请输入创建时间',
          trigger: 'blur'
        }],
        method: [{
          required: true,
          message: '请输入方法',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '请输入名称标识',
          trigger: 'blur'
        }],
        operationType: [{
          required: true,
          message: '请输入操作类型',
          trigger: 'blur'
        }],
        operatorId: [{
          required: true,
          message: '请输入操作人Id',
          trigger: 'blur'
        }],
        operatorName: [{
          required: true,
          message: '请输入操作人账号',
          trigger: 'blur'
        }],
        requestBody: [{
          required: true,
          message: '请输入请求体',
          trigger: 'blur'
        }],
        responseBody: [{
          required: true,
          message: '请输入返回体',
          trigger: 'blur'
        }],
        runTime: [{
          required: true,
          message: '请输入执行时间',
          trigger: 'blur'
        }],
        serviceName: [{
          required: true,
          message: '请输入',
          trigger: 'blur'
        }],
        stats: [{
          required: true,
          message: '请输入0 成功 1失败',
          trigger: 'blur'
        }],
        url: [{
          required: true,
          message: '请输入请求地址',
          trigger: 'blur'
        }],
        message: [{
          required: true,
          message: '请输入请求错误日志',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    checkStats: function checkStats(value) {
      var _iterator = _createForOfIteratorHelper(this.logStats),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var res = _step.value;
          var val = parseInt(res.keys);
          if (val === value) {
            return res.values;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },
    checkStatsTypes: function checkStatsTypes(value) {
      var _iterator2 = _createForOfIteratorHelper(this.logStatsTypes),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var res = _step2.value;
          var val = parseInt(res.keys);
          if (val === value) {
            return res.values;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    },
    initEunmData: function initEunmData() {
      this.getLogStatsEnumList('log_stats');
      this.getLogStatsTypeEnumList('log_stats_type');
    },
    getLogStatsEnumList: function getLogStatsEnumList(name) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var par, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              par = {
                name: name
              };
              _context.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context.v;
              _this.logStats = res.body;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    getLogStatsTypeEnumList: function getLogStatsTypeEnumList(name) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var par, res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              par = {
                name: name
              };
              _context2.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context2.v;
              _this2.logStatsTypes = res.body;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    setTitle: function setTitle(title) {
      this.title = title;
    },
    initData: function initData() {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.createTime = null;
      this.form.method = null;
      this.form.name = null;
      this.form.operationType = null;
      this.form.operatorId = null;
      this.form.operatorName = null;
      this.form.requestBody = null;
      this.form.responseBody = null;
      this.form.runTime = null;
      this.form.serviceName = null;
      this.form.stats = null;
      this.form.url = null;
      this.form.message = null;
    },
    setData: function setData(data) {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.createTime = data.createTime;
      this.form.method = data.method;
      this.form.name = data.name;
      this.form.operationType = data.operationType;
      this.form.operatorId = data.operatorId;
      this.form.operatorName = data.operatorName;
      this.form.requestBody = data.requestBody;
      this.form.responseBody = data.responseBody;
      this.form.runTime = data.runTime;
      this.form.serviceName = data.serviceName;
      this.form.stats = data.stats;
      this.form.url = data.url;
      this.form.message = data.message;
    },
    updateApi: function updateApi() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return api.UPDATE_LOG(_this3.form);
            case 1:
              _this3.$emit('initTableData');
              _this3.$message.success('操作成功');
              _this3.handleClose();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    saveApi: function saveApi() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return api.SAVE_LOG(_this4.form);
            case 1:
              _this4.$emit('initTableData');
              _this4.$message.success('操作成功');
              _this4.handleClose();
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    save: function save() {
      var _this5 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (_this5.form.id != null) {
            _this5.$confirm('此操作将永久修改该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(function () {
              _this5.updateApi();
            }).catch(function () {
              _this5.$message({
                type: 'info',
                message: '已取消修改'
              });
            });
          } else {
            _this5.saveApi();
          }
        } else {
          return false;
        }
      });
    },
    handleClose: function handleClose(done) {
      this.$emit('close');
    }
  },
  created: function created() {
    this.initEunmData();
  }
};